import { useLogin, useLink } from "@refinedev/core";
import { Input, Checkbox, Password } from "../../components/Inputs";
import Form from "../../lib/Form";
import {
  FormContent,
  FormWrapper,
  SwitchText,
} from "../../components/Layout/forms";
import { YumyButton } from "../../components/ButtonsAndLinks";

export default function Login() {
  const { mutate: onLogin } = useLogin();
  const Link = useLink();
  return (
    <FormWrapper>
      <FormContent>
        <h1>Log ind</h1>
        <Form
          initialValues={{ email: "", password: "", rememberMe: true }}
          onFinish={(fields) => onLogin(fields)}
        >
          <Input label="Email" name="email" />
          <Password
            size="large"
            name="password"
            label="Kodeord"
            topRight={<Link to="/forgot">Glemt?</Link>}
          />
          <Checkbox name="rememberMe">Hold mig logget ind</Checkbox>
          <YumyButton>
            Log ind
          </YumyButton>
        </Form>
        <SwitchText>
          Brug for en Yumy-konto? <Link to="/register">Opret en konto</Link>
        </SwitchText>
      </FormContent>
    </FormWrapper>
  );
}
